




































import Modal from "../../core/Modals/Modal.vue";
import { Employe } from "../../models/Employe";
import EWorkingHourDay = Employe.EWorkingHourDay;
import TimeInput from "../../core/Forms/TimeInput.vue";
import PlanningWorkingHour = Employe.PlanningWorkingHour;

export default {
    name: "AddHourModal",
    components: { TimeInput, Modal },
    props: {
        day: EWorkingHourDay,
        showModal: Boolean,
    },
    data() {
        return {
            workingHour: new PlanningWorkingHour({}),
        };
    },
    methods: {
        closeModal(data): void {
            this.$emit("close-modal", data);
        },
    },
    computed: {
        isValid(): boolean {
            let hourRegEx = /^([0-1][0-9]|2[0-3])h[0-5][0-9]$/;
            return (
                this.workingHour.heure_debut &&
                hourRegEx.test(this.workingHour.heure_debut) &&
                this.workingHour.heure_fin &&
                hourRegEx.test(this.workingHour.heure_fin)
            );
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.workingHour = new PlanningWorkingHour({
                        jour: this.day,
                        heure_debut: "",
                        heure_fin: "",
                    });
                }
            },
        },
    },
};
